import { useEffect, useMemo, useRef, useState } from 'react';

const ITEMS = [
  'Initiate Player Control Access Sequence',
  'Awaken Campaign Manager Spirit',
  'Machine Setting Protocols',
];

export default function CampaignSelectionMenu({ isOn }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const rootRef = useRef(null);

  const items = useMemo(() => ITEMS, []);

  useEffect(() => {
    if (!isOn) return;
    rootRef.current?.focus?.();
  }, [isOn]);

  const clamp = (n) => Math.max(0, Math.min(items.length - 1, n));

  const onKeyDown = (e) => {
    if (!isOn) return;

    if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActiveIndex((i) => clamp(i - 1));
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActiveIndex((i) => clamp(i + 1));
    } else if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  return (
    <div
      ref={rootRef}
      className={`campaignMenu computer-text ${isOn ? 'is-on' : ''}`}
      tabIndex={0}
      onKeyDown={onKeyDown}
      role="menu"
      aria-label="Campaign selection"
    >
      {items.map((label, idx) => {
        const isActive = idx === activeIndex;
        return (
          <button
            key={label}
            type="button"
            className={`campaignMenu__item ${isActive ? 'is-active' : ''}`}
            role="menuitem"
            onMouseEnter={() => setActiveIndex(idx)}
            onFocus={() => setActiveIndex(idx)}
            onClick={() => {}}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
